import React from "react";

import { DecorativeDot } from "../../../lib/styles";
import { HOMEPAGE_ANCHOR_CONTAINER_IDs } from "../../../lib/constants";

import * as S from "./styles";

const benefitsData = [
  {
    stat: "3X+",
    title: "voter engagement",
    description: "Make constituents feel heard",
    avatar: "/images/benefits/avatar1.jpg",
  },
  {
    stat: "6X+",
    title: "donations",
    description: "Supercharge your fundraising",
    avatar: "/images/benefits/avatar2.jpg",
  },
  {
    stat: "5M+",
    title: "messages",
    description: "Connect with voters at scale",
    avatar: "/images/benefits/avatar3.jpg",
  },
];

export function BenefitsSection() {
  return (
    <S.StyledSection id={HOMEPAGE_ANCHOR_CONTAINER_IDs.benefits.key}>
      <S.HeadingContainer>
        <S.HeadingLine>
          We deliver real, impactful results for our <br />
          clients{" "}
          <S.AvatarGroup>
            <div>
              {benefitsData.map((item, index) => (
                <S.AvatarImage
                  key={index}
                  src={item.avatar}
                  alt={`${item.title} client`}
                />
              ))}
            </div>
          </S.AvatarGroup>{" "}
          revolutionizing the politics{" "}
          <span>
            and <br />
            advocacy landscapes
            <DecorativeDot
              src="/images/icons/dot-grey.svg"
              alt="Decorative dot"
            />
          </span>
        </S.HeadingLine>
      </S.HeadingContainer>
      <S.SeparatorContainer>
        <S.SeparatorDot />
        <S.SeparatorLine />
        <S.SeparatorDot />
      </S.SeparatorContainer>
      <S.ContentWrapper>
        <S.IntroTextCard>
          <S.IntroTextBox>
            With Reach, we're changing how campaigns are run by combining <br />
            <strong>personalized</strong>, <strong>scalable outreach</strong>,{" "}
            <strong>AI-driven fundraising</strong>, and{" "}
            <strong>real-time sentiment analysis</strong>{" "}
            <strong className="hl">in one powerful tool</strong>.
          </S.IntroTextBox>
        </S.IntroTextCard>
        <S.BenefitsGrid>
          {benefitsData.map((benefit, index) => (
            <S.BenefitCardWrapper key={index} $isMiddleCard={index === 1}>
              <S.BenefitCard>
                <S.BenefitCardInnerWrapper>
                  <S.BenefitStatContainer>
                    <S.BenefitStatNumber>{benefit.stat}</S.BenefitStatNumber>
                    <S.BenefitArrowIcon />
                  </S.BenefitStatContainer>
                  <S.BenefitTitle>{benefit.title}</S.BenefitTitle>
                </S.BenefitCardInnerWrapper>
                <S.BenefitDescription>
                  {benefit.description || <>&nbsp;</>}
                </S.BenefitDescription>
              </S.BenefitCard>
            </S.BenefitCardWrapper>
          ))}
        </S.BenefitsGrid>
      </S.ContentWrapper>
    </S.StyledSection>
  );
}
